(function () {
  function initTabs() {
    var buttons = document.querySelectorAll('.koc-tab-btn');
    if (buttons.length === 0) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tabId = btn.getAttribute('data-tab');

        document.querySelectorAll('.koc-tab-content').forEach(function (t) {
          t.classList.remove('active');
        });
        document.querySelectorAll('.koc-tab-btn').forEach(function (b) {
          b.classList.remove('active');
        });

        document.getElementById(tabId).classList.add('active');
        btn.classList.add('active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
  } else {
    initTabs();
  }
})();